var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickDisableButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 100 100",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#______src_modules_popup_svg_TickDisableButton_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#______src_modules_popup_svg_TickDisableButton_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#______src_modules_popup_svg_TickDisableButton_svg__c)",
    d: "M0 50C0 22.386 22.386 0 50 0s50 22.386 50 50-22.386 50-50 50S0 77.614 0 50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#565656",
    strokeWidth: 4.167,
    d: "M2.083 50C2.083 23.536 23.536 2.083 50 2.083S97.917 23.536 97.917 50 76.464 97.917 50 97.917 2.083 76.464 2.083 50Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#565656",
    d: "M40.436 61.984 30.08 51.252a2.9 2.9 0 0 0-4.208 0 3.16 3.16 0 0 0 0 4.361L38.347 68.54a2.9 2.9 0 0 0 4.207 0l31.573-32.72a3.16 3.16 0 0 0 0-4.36 2.9 2.9 0 0 0-4.208 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "______src_modules_popup_svg_TickDisableButton_svg__c",
    x1: 0,
    x2: 100,
    y1: 0,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221E1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "______src_modules_popup_svg_TickDisableButton_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "______src_modules_popup_svg_TickDisableButton_svg__b",
    width: 111.111,
    height: 111.111,
    x: -5.556,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.778
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_1143"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_1143",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickDisableButton);
export default __webpack_public_path__ + "static/media/TickDisableButton.f69b0ef714716e2fa9aaa0e7f790d86b.svg";
export { ForwardRef as ReactComponent };